var $3701354d5ce12450$exports = {};
$3701354d5ce12450$exports = {
    "breadcrumbs": `Caminho detalhado`
};


export {$3701354d5ce12450$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
